import React, { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
// import { faWindowRestore } from "@fortawesome/free-solid-svg-icons";

const LoginData = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({ username: null, rights: null });
  const [right, setRight] = useState(null);

  // async function setData(keycloak) {
  //   tokens = {
  //     access_token: keycloak.token,
  //     refresh_token: keycloak.refreshToken,
  //   };
  //   roles = keycloak.tokenParsed.realm_access.roles;

  //   sessionStorage.setItem("access_token", tokens.access_token);
  //   sessionStorage.setItem("refresh_token", tokens.refresh_token);
  //   sessionStorage.setItem("id_token", keycloak.idToken);
  //   sessionStorage.setItem("realm", keycloak.realm);
  //   sessionStorage.setItem("client", keycloak.clientId);

  //   data = {
  //     username: keycloak.tokenParsed.preferred_username,
  //     rights: roles.includes("view-dashboard") ? "A" : "E",
  //     token: tokens,
  //   };

  //   sessionStorage.setItem("username", data.username);
  //   sessionStorage.setItem("rights", data.rights);

  //   // setInterval(() => {
  //   //   keycloak
  //   //     .updateToken(30) // Check if the token will expire within 30 seconds
  //   //     .then((refreshed) => {
  //   //       if (refreshed) {
  //   //         setData(keycloak)
  //   //         console.log('Token refreshed');
  //   //       } else {
  //   //         console.log('Token not refreshed, still valid');
  //   //       }
  //   //     })
  //   //     .catch((err) => {
  //   //       console.error('Failed to refresh token:', err);
  //   //       keycloak.logout(); // Redirect to login on token refresh failure
  //   //     });
  //   // }, 300000);
  // }
  useEffect(() => {
    console.log("Navigating start");
  
    async function setDetails() {
      let username = sessionStorage.getItem("username");
      let rights = sessionStorage.getItem("rights");
  
      if (!rights || rights === "null") {
        console.warn("No rights found in sessionStorage!");
        return;
      }
  
      console.log("Rights:", rights);
  
      const newData = { username, rights };
      setData(newData);
  
      if (rights === "A") {
        navigate("/DashBoard", { state: newData });
      } else {
        navigate("/TripBooking", { state: newData });
      }
    }
  
    setTimeout(setDetails, 3000);
  }, [sessionStorage.getItem('access_token')]);
  

  return (
    <div>
      <Loading />
    </div>
  );
};

export default LoginData;
